export const axiosUrl = {
  partners: {
    getPartners: '/ecom/partners',
    addPartner: '/ecom/partner'
  },
  stores: {
    getStores: '/ecom/stores',
    deleteStores: '/ecom/stores'
  },
  products: {
    getProducts: '/ecom/productMaps',
    deleteProducts: '/ecom/productMaps',
    saveProduct: '/ecom/productMap',
    productBulkUpload: '/ecom/productMaps/bulk'
  },
  customers: {
    getCustomers: '/customers',
    getCustomerByid: '/customer',
    postCustomer: '/customer',
    deleteCustomers: '/customer',
    exportToExcel: '/customers',
    uploadBulkEndpoint: '/customer/bulk'
  },
  workflow: {
    getWorkflow: '/collection/workflow-templates',
    getWorkflowTemplate: '/collection/workflow-templates',
    postWorkflow: '/collection/workflow-templates',
    deleteWorkflow: '/collection/workflow-templates',
    putWorkflow: '/collection/workflow-templates'
  },
  employees: {
    getEmployees: '/v3/users',
    getApproval: '/v3/users',
    getManagers: '/users?roleAssigned=true',
    importEmployees: '/import/users',
    inActiveEmployees: '/report/users/notloggedIn'
  },
  role: {
    getRoles: '/org/role/v2',
    postRoles: '/org/role/v2',
    putRoles: '/org/role/v2',
    deleteRoles: '/org/role/v2',
    fetchRole: '/org/role',
    populatePermissions: '/org/role/modules/v2',
    populateModulesConfig: '/org/role/modules/config/v2'
  },
  users: {
    getUsers: '/v3/users',
    getLocations: '/user/v2/location'
  },
  branches: {
    getBranches: '/branches',
    deleteBranches: '/branch',
    putBranches: '/branch',
    postBranches: '/branch',
    saveGeofence: '/branch',
    getUseCases: '/orgSetup/extend-usecase?useCa'
  },
  teams: {
    getTeams: '/teams',
    deleteTeams: '/team',
    putTeams: '/team',
    postTeams: '/team'
  },
  departments: {
    getDepartments: '/orgSetup/departments',
    deleteDepartments: '/orgSetup/departments',
    putDepartments: '/orgSetup/departments',
    postDepartments: '/orgSetup/departments'
  },
  designations: {
    getDesignations: '/orgSetup/designations',
    deleteDesignations: '/orgSetup/designations',
    putDesignations: '/orgSetup/designations',
    postDesignations: '/orgSetup/designations'
  },
  cases: {
    getLoanCases: '/collection/loan?subCase',
    getCases: '/collection',
    updateCase: '/collection/case',
    deleteCase: '/collection/case',
    deletAllCase: '/collection/case?caseType',
    getEntities: '/collection/entities',
    updateVisit: '/collection/case/task',
    getAuditLogs: '/collection/loan-audit',
    uploadCaseDocuments: '/case/documents'
  },
  fetchAnalytics: {
    getAnalytics: '/collection/cases/analytics'
  },
  ledgerGroups: {
    getLedgerGroups: '/orgSetup/ledger-groups',
    postLedgerGroup: '/orgSetup/ledger-groups',
    putLedgerGroup: '/orgSetup/ledger-groups',
    deleteLedgerGroup: '/orgSetup/ledger-groups'
  },
  accounts: {
    getAccounts: '/orgSetup/accounts-management',
    postAccount: '/orgSetup/accounts-management',
    putAccount: '/orgSetup/accounts-management',
    deleteAccount: '/orgSetup/accounts-management'
  },
  journals: {
    getJournals: '/orgSetup/journals',
    postJournal: '/orgSetup/journals',
    putJournal: '/orgSetup/journals',
    deleteJournal: '/orgSetup/journals'
  },
  loanRules: {
    getLoanRules: '/collection/loan-rule',
    postLoanRule: '/collection/loan-rule',
    putLoanRule: '/collection/loan-rule',
    deleteLoanRule: '/collection/loan-rule'
  }
}
